import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paidButton", "paidContainer", "paidAtInput", "form",
    "paymentTotal", "visits", "paymentTotalInput"];


  connect() {
    console.debug("GymPaymentReportFormController connected", this.formTarget);
    // console.table(
    //   {
    //     "Price class": this.price_per_class,
    //     "Attended": this.attended,
    //     "Not Attended": this.not_attended,
    //     "Reserved": this.reserved,
    //     "Cancelled": this.cancelled,
    //     "Price extra class": this.price_per_extra_class,
    //     "Attended extra": this.attended_extra,
    //     "Not Attended extra": this.not_attended_extra,
    //     "Reserved extra": this.reserved_extra,
    //     "Cancelled extra": this.cancelled_extra
    //   }
    // );
  }

  updateTotals(event) {
    console.log("Update totals");

    this.paymentTotalInputTarget.value = this.payment;
    this.paymentTotalTarget.textContent = new Intl.NumberFormat(
      "es-MX",
      {style: "currency", currency: "MXN",}
    ).format(this.payment);

    this.visitsTarget.textContent = this.visits;
  }

  get visits() {
    return this.attended + this.not_attended + this.attended_extra + this.not_attended_extra;
  }

  get payment() {
    const normal = (this.attended + this.not_attended) * this.price_per_class;
    const extras = (this.attended_extra + this.not_attended_extra) * this.price_per_extra_class;

    return normal + extras;
  }


  get price_per_class() {
    return this.formTarget[this.modelScope + '_price_per_class'].valueAsNumber;
  }

  get attended() {
    return this.formTarget[this.modelScope + '_attended'].valueAsNumber;
  }

  get not_attended() {
    return this.formTarget[this.modelScope + '_not_attended'].valueAsNumber;
  }

  get reserved() {
    return this.formTarget[this.modelScope + '_reserved'].valueAsNumber;
  }

  get cancelled() {
    return this.formTarget[this.modelScope + '_cancelled'].valueAsNumber;
  }

  get price_per_extra_class() {
    return this.formTarget[this.modelScope + '_price_per_extra_class'].valueAsNumber;
  }

  get attended_extra() {
    return this.formTarget[this.modelScope + '_attended_extra'].valueAsNumber;
  }

  get not_attended_extra() {
    return this.formTarget[this.modelScope + '_not_attended_extra'].valueAsNumber;
  }

  get reserved_extra() {
    return this.formTarget[this.modelScope + '_reserved_extra'].valueAsNumber;
  }

  get cancelled_extra() {
    return this.formTarget[this.modelScope + '_cancelled_extra'].valueAsNumber;
  }

  get modelScope() {
    return "gym_payment_report";
  }

  markAsPaid(event) {
    console.log("Mark as paid", event.params.date);
    this.paidButtonTarget.classList.add("d-none");
    this.paidContainerTarget.classList.remove("d-none");
    this.paidAtInputTarget.value = event.params.date;
  }
}
